import axios from 'axios';
import { convertISODateStringsToDates } from "./api";
var publicApi = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
});
publicApi.interceptors.request.use(function (config) {
    var publicKey = localStorage.getItem('crqlarPublicKey');
    if (publicKey) {
        if (!config.headers) {
            // @ts-ignore
            config.headers = {};
        }
        config.headers['publicKey'] = publicKey;
    }
    return config;
});
/*
    We need this in cases where the internal user accesses booking engine and system needs to track his data
    User logs for example
*/
publicApi.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    if (token) {
        if (!config.headers) {
            // @ts-ignore
            config.headers = {};
        }
        config.headers['Authorization'] = token;
    }
    return config;
});
publicApi.interceptors.response.use(function (originalResponse) {
    convertISODateStringsToDates(originalResponse.data);
    return originalResponse;
});
export default publicApi;
